import React, { useState, useRef, useEffect } from 'react';
import { QrCodeScanner as QrCodeScannerIcon, Edit as EditIcon } from "@mui/icons-material";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import MainPagination from '../general/MainPagination';
import AdvertisementService from '../../../services/advertisements';
import { formatDate } from '../../../utils/function';
import { Global } from '../../../utils/general';
import { Toast } from '../../../utils/alerts';
import { CODES } from '../../../utils/responseCodes';
import html2canvas from "html2canvas";
import { IconButton, Tooltip } from '@mui/material';
import logoImg from "../../../assets/img/logo.png";
import QRCodeStyling from "qr-code-styling";
import CopyAllIcon from '@mui/icons-material/CopyAll';
import ShareIcon from '@mui/icons-material/Share';
import AddUserToFolder from '../../pages/Advertisements/AddUserToFolder/AddUserToFolder';

const BodyAdvertisements = (props) => {
  const { setTitleModalLoader, setOpenModalLoader, handleOpenModal, getAdvertisements, records, totalPages, page, setPage, desCarpetaSel, isJefe ,carpetaSeleccionada} = props;
 
  const urlAdvertisement = Global.urlAdvertisement;
  const [selectedQR, setSelectedQR] = useState(null);
  const [openShared, setOpenShared] = useState(null);
  const handleClose = () => setOpenShared(false);
  const qrRef = useRef(null);

  const qrCode = useRef(null);

  // Generar QR con logo cuando cambia la URL
  useEffect(() => {
    if (selectedQR && qrRef.current) {
      qrRef.current.innerHTML = ""; // limpiar antes de volver a generar
      qrCode.current = new QRCodeStyling({
        width: 340,
        height: 280,
        image: logoImg,
        imageOptions: {
          crossOrigin: "anonymous",
          margin: 5,
          imageSize: 1.5,
        },
        dotsOptions: {
          color: "#000000",
          type: "rounded",
        },
        backgroundOptions: {
          color: "#ffffff",
        },
        cornersSquareOptions: {
          type: "extra-rounded",
        },
        cornersDotOptions: {
          type: "dot",
        },
      });
      qrCode.current.update({
        data: selectedQR.url,
      });

      // 👉 renderízalo
      qrCode.current.append(qrRef.current);
    }
  }, [selectedQR]);

  const downloadAdvertisement = async (fileName, nombre) => {
    try {
      setOpenModalLoader(true);
      setTitleModalLoader("Buscando archivo ...");
      const body = { advertisement: fileName }
      const result = await AdvertisementService.downloadAdvertisement(body);
      if (result.status === CODES.SUCCESS_200) {
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${nombre}.pdf`);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
      } else {
        Toast.fire({ icon: 'error', title: 'Error al descargar el archivo o documento no disponible.' });
      }
    } catch (error) {
      console.log(`Error al descargar el archivo: ${error}`);
    } finally {
      setOpenModalLoader(false);
      setTitleModalLoader(null);
    }
  }
  const downloadQR = async (event) => {
    event.stopPropagation();
    const qrContainer = document.querySelector('.qr-container');
    if (!qrContainer) return;

    try {
      const canvas = await html2canvas(qrContainer);
      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = `QR_${selectedQR.codigo}.png`;
      link.click();
    } catch (err) {
      console.error("Error al descargar QR con código:", err);
    }
  };

  const deleteAdvertisement = async (id_anuncio) => {
    if (!id_anuncio) {
      Toast.fire({ icon: "info", title: "El anuncio aun no esta creado." });
      return;
    }
    const result = await Toast.fire({
      icon: 'question',
      title: '¿Seguro de desactivar el anuncio?',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      confirmButtonColor: "#218838",
      cancelButtonColor: "#dc3545",
      timer: 10000,
      timerProgressBar: true,
    });

    if (result.isConfirmed) {
      setOpenModalLoader(true);
      setTitleModalLoader("Desactivando el anuncio ...");
      try {
        const result = await AdvertisementService.deleteAdvertisement(id_anuncio);
        if (result.status === CODES.DELETE_204) {
          Toast.fire({ icon: 'success', title: 'Anuncio desactivado correctamente' });
          getAdvertisements();
        } else {
          Toast.fire({ icon: 'error', title: 'No se pudo desactivar el anuncio. Inténtalo nuevamente' });
        }
        return [];
      } catch (error) {
        console.log(`Error en eliminarMof: ${error}`);
      } finally {
        setOpenModalLoader(false);
        setTitleModalLoader(null);
      }
    }
  };

  return (
    <div className="container mt-3">
     <AddUserToFolder 
      open={openShared}
      setOpenShared={setOpenShared}
      handleClose={handleClose}
      carpetaSeleccionada={carpetaSeleccionada} setOpenModalLoader={setOpenModalLoader}
     />

      {desCarpetaSel && (
        <div className="mb-4 text-center">
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.5rem' }}>
            <h5 className="fw-bold text-primary m-0">
             CARPETA - {desCarpetaSel.toUpperCase()}
            </h5>
            {isJefe.isJefe && (
              <Tooltip title="Compartir" arrow>
                <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => setOpenShared(true)}>
                  <ShareIcon fontSize="medium" />
                </button>
              </Tooltip>
            )}
          </div>
        </div>
      )}

      <div className="row">
        {records?.map((ad, index) => (
          <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 mb-3">
            <div
              onClick={() => {
                if (+ad.estado_id === 1) {
                  setSelectedQR({ url: `${urlAdvertisement}/${ad.ruta}`, codigo: ad.codigo, nombre: ad.nombre });
                }
              }}
              className={`card text-center p-2 shadow-sm h-100 ${+ad.estado_id !== 1 ? "bg-danger bg-opacity-10 border-danger" : ""}`}
            >
              <div className="mt-auto d-flex align-items-center justify-content-center gap-3">
                <button type="button" className="btn btn-outline-success btn-sm"
                  onClick={(e) => {
                    e.stopPropagation(); // Detiene la propagación al div.card
                    downloadAdvertisement(ad.ruta, ad.nombre);
                  }}
                  style={{
                    padding: 0,
                    cursor: +ad.estado_id === 1 ? "pointer" : "not-allowed",
                    opacity: +ad.estado_id === 1 ? 1 : 0.5,
                  }}
                >
                  <CloudDownloadIcon fontSize="medium" />
                </button>
                {(+ad.estado_id === 1) &&
                  <>
                    {/*<button type="button" className="btn btn-outline-dark btn-sm"
                      //onClick={() => setSelectedQR(`${urlAdvertisement}/${ad.ruta}`)}
                      onClick={() => setSelectedQR({ url: `${urlAdvertisement}/${ad.ruta}`, codigo: ad.codigo,nombre: ad.nombre })}
                      style={{
                        padding: 0,
                        cursor: +ad.estado_id === 1 ? "pointer" : "not-allowed",
                        opacity: +ad.estado_id === 1 ? 1 : 0.5,
                      }}
                    >
                      <QrCodeScannerIcon fontSize="medium" />
                    </button>*/
                    }
                    <button type="button" className="btn btn-outline-dark btn-sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigator.clipboard.writeText(`${urlAdvertisement}/${ad.ruta}`);
                        Toast.fire({ icon: 'success', title: 'URL copiada' });
                      }}
                      style={{
                        padding: 0,
                        cursor: +ad.estado_id === 1 ? "pointer" : "not-allowed",
                        opacity: +ad.estado_id === 1 ? 1 : 0.5,
                      }}
                    >
                      <CopyAllIcon fontSize="medium" />
                    </button>
                    <button type="button" className="btn btn-outline-primary btn-sm"
                      onClick={(e) => { e.stopPropagation(); handleOpenModal(ad) }}
                      style={{
                        padding: 0,
                        cursor: +ad.estado_id === 1 ? "pointer" : "not-allowed",
                        opacity: +ad.estado_id === 1 ? 1 : 0.5,
                      }}
                    >
                      <EditIcon fontSize="medium" />
                    </button>
                    <button type="button" className="btn btn-outline-danger btn-sm"
                      onClick={(e) => { e.stopPropagation(); deleteAdvertisement(ad?.id_anuncio) }}
                      style={{
                        padding: 0,
                        cursor: +ad.estado_id === 1 ? "pointer" : "not-allowed",
                        opacity: +ad.estado_id === 1 ? 1 : 0.5,
                      }}
                    >
                      <DeleteForeverIcon fontSize="medium" />
                    </button>
                  </>
                }
              </div>
              <p className="text-muted small mb-2 mt-2">{ad.nombre}</p>
              <div className="mt-auto">
                <p className="small mb-1">{ad.trabajador}</p>
                <p className="small mb-0">{formatDate(new Date(ad.fechaMod))}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {selectedQR && (
        <div className="qr-overlay" onClick={() => setSelectedQR(null)}>
          <div className="qr-container" onClick={(e) => e.stopPropagation()}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <p style={{
                marginTop: "1rem",
                fontWeight: "600",
                fontSize: "1.2rem",
                color: "#333",
                textAlign: "center",
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
              }}>
                OBIETTIVO LAVORO
              </p>
              <p style={{

                fontWeight: "600",
                fontSize: "1.2rem",
                color: "#333",
                textAlign: "center",
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
              }}>
                {selectedQR.nombre}
              </p>
              <div ref={qrRef} style={{ cursor: "pointer" }} onClick={downloadQR}></div>
              <p style={{

                fontWeight: "600",
                fontSize: "1.5rem",
                color: "#333",
                textAlign: "center",
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
              }}>
                {selectedQR.codigo}
              </p>
            </div>
          </div>
        </div>
      )}

      <MainPagination
        size={'small'}
        totalPages={totalPages}
        page={page}
        setPage={setPage}
      />
    </div>
  );
};

export default BodyAdvertisements;
